"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { copyToClipboard } from "../../lib/copyToClipboard";
import { Check, Copy } from "../Icon";
import { Animate } from "../Transition";
import { Button } from "./Button";
export const CopyButton = ({ children, copyValue, onClick, ...restProps }) => {
    const [copied, setCopied] = useState(false);
    const copiedTimeout = useRef(null);
    const handleClick = (evt) => {
        // No-op when copied is true
        if (copied) {
            return;
        }
        setCopied(true);
        onClick?.(evt);
        // Copy content to clipboard
        // NOTE: Failures are a silent no-op
        copyToClipboard(typeof copyValue === "function" ? copyValue() : copyValue);
        copiedTimeout.current = window.setTimeout(() => {
            setCopied(false);
        }, 1300);
    };
    useEffect(() => {
        return () => {
            if (copiedTimeout.current)
                clearTimeout(copiedTimeout.current);
        };
    }, []);
    return (_jsxs(Button, { ...restProps, onClick: handleClick, children: [_jsx(Animate, { className: "w-[var(--button-icon-size)] h-[var(--button-icon-size)]", initial: { scale: 0.6 }, enter: { scale: 1, delay: 150, duration: 300 }, exit: { scale: 0.6, duration: 150 }, forceCompositeLayer: true, children: copied ? _jsx(Check, {}, "copied-icon") : _jsx(Copy, {}, "copy-icon") }), typeof children === "function" ? children({ copied }) : children] }));
};
//# sourceMappingURL=CopyButton.js.map